import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Nav2 from '../../Nav2/Nav2';
import BannerKesehatan from '../CategoryBanner/bannerkesehatan';
import Content from '../Content/Content';
import '../Pendidikan/category.css'




const Kesehatan = () => {
    const [content, setContent] = useState([])

    const fetchKesehatan = async () => {
        const { data } = await axios.get(
            'https://weshare-heroku.herokuapp.com/api/weShare/category/'
        )
        setContent(data.data[0].OpenDonations)
    }

    useEffect(() => {
        fetchKesehatan()
    }, [])

    return (
        <div>
            <Nav2 />
            <BannerKesehatan />
            <div className="title-category">
                <div className="kesehatan">
                    {
                        content && content.map((c) => (
                            <Content
                                key={c.id}
                                name={c.donationName}
                                need={c.donationNeeded}
                                expired={c.expiredDate}
                                image={c.image}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Kesehatan;
